exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cascader-popover[data-v-5203ce3d] .bui-cascader-menus .bui-cascader-menu-item .bui-cascader-custom-render-item .byted-popover-wrapper .ref-word{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:160px;height:18px}\n", ""]);

